import {
	grayColor,
	avatarColors,
	profileSupportColor,
	menuHoverBgColor,
	whiteColor,
} from 'assets/jss/material-dashboard-pro-react';

const profileDetailsStyles = (theme) => ({
	popper: {
		zIndex: theme.zIndex.tooltip,
	},
	popperMobile: {
		position: 'fixed !important',
		width: '100vw',
		height: '100vh',
		top: 0,
		left: 0,
		transform: 'none !important',
		backgroundColor: whiteColor,
	},
	drawer: {
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			width: '50%',
			maxWidth: '320px',
		},
	},
	drawerPaper: {
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			width: '50%',
			maxWidth: '320px',
		},
	},
	profileCard: {
		minWidth: '300px',
		padding: '1.5rem',
		height: '100%',
		boxShadow: 'none',
		[theme.breakpoints.up('lg')]: {
			borderRadius: '16px',
			boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
		},
	},
	cardContent: {
		padding: 0,
		'&:last-child': {
			padding: 0,
		},
		'& img': {
			width: '24px',
			height: '24px',
		},
	},
	avatar: {
		backgroundColor: avatarColors.bg,
		color: avatarColors.text,
		width: '50px',
		height: '50px',
		fontWeight: 700,
		fontSize: theme.fontSize(16),
	},
	userInfo: {
		fontWeight: 700,
		marginBottom: 0,
	},
	userType: {
		textTransform: 'uppercase',
		color: `${profileSupportColor} !important`,
	},
	avatarContainer: {
		paddingBottom: '1rem',
		borderBottom: `1px solid ${grayColor[1]}`,
		marginBotton: '1rem',
	},
	actions: {
		'&:hover,&:focus,&:active': { background: menuHoverBgColor, borderRadius: '1rem' },
		'& .MuiListItemIcon-root': {
			minWidth: '36px',
		},
		'& .MuiListItemText-primary': {
			fontFamily: theme.fontFamily.albert.regular,
		},
	},
	closeButton: {
		padding: '0 0.2rem',
		height: '50px',
		justifyContent: 'flex-end',
	},
});

export default profileDetailsStyles;
